module.exports = __webpack_public_path__ + "static/media/logo.3ca2237a.svg";